import { useState } from 'react';

// Поля протокола Алёны — БЕЗ % жира (считается автоматически)
const GROUPS = [
  {
    title: 'Основные',
    fields: [
      { key:'measured_at', label:'Дата замера', type:'date', required:true,
        hint:'Замеры делаются утром, натощак, после туалета' },
      { key:'weight_kg', label:'Вес', unit:'кг', placeholder:'62.5',
        hint:'Взвешивайся в одно и то же время, в одной одежде (или без)' },
    ],
  },
  {
    title: 'Верхняя часть',
    fields: [
      { key:'chest_cm',  label:'Грудь',   unit:'см', placeholder:'88.0',
        hint:'Самая широкая часть груди' },
      { key:'bicep_cm',  label:'Бицепс',  unit:'см', placeholder:'28.0',
        hint:'Рука опущена вниз и расслаблена — самая широкая часть' },
    ],
  },
  {
    title: 'Средняя зона',
    fields: [
      { key:'waist_cm',   label:'Талия',  unit:'см', placeholder:'70.0',
        hint:'Самая узкая часть — живот расслаблен, не втягивай' },
      { key:'abdomen_cm', label:'Живот',  unit:'см', placeholder:'82.0',
        hint:'Низ живота — проблемная зона, не втягивай' },
    ],
  },
  {
    title: 'Нижняя часть',
    fields: [
      { key:'hips_cm',        label:'Бёдра',        unit:'см', placeholder:'96.0',
        hint:'Между лобковой костью и серединой ягодицы — самая выпуклая часть' },
      { key:'thigh_cm',       label:'Бедро',        unit:'см', placeholder:'56.0',
        hint:'Самая широкая часть бедра' },
      { key:'above_knee_cm',  label:'Над коленом',  unit:'см', placeholder:'38.0',
        hint:'Отступи 1-2 пальца выше коленной чашечки — самая широкая часть' },
      { key:'calf_cm',        label:'Голень',       unit:'см', placeholder:'35.0',
        hint:'Самая широкая часть голени' },
    ],
  },
];

const today = () => new Date().toISOString().slice(0,10);

const CSS = `
  .mf-inp { width:100%; padding:.65rem .85rem; border-radius:10px; background:rgba(255,255,255,.06); border:1.5px solid rgba(255,255,255,.1); color:#F2EEF9; font-size:.875rem; outline:none; box-sizing:border-box; transition:all .2s; }
  .mf-inp::placeholder { color:rgba(158,140,184,.5); }
  .mf-inp:focus { border-color:var(--accent,#C8005A); background:rgba(255,255,255,.1); box-shadow:0 0 0 3px rgba(200,0,90,.15); }
  .mf-inp[type=date]::-webkit-calendar-picker-indicator { filter:invert(1) opacity(.4); cursor:pointer; }
`;

export default function MeasurementForm({ initial={}, onSubmit, loading, onCancel, gender }) {
  const [values, setValues] = useState({ measured_at: today(), ...initial });
  const [error,  setError]  = useState('');
  const set = (k,v) => setValues(p=>({...p,[k]:v}));

  const handleSubmit = async (e) => {
    e.preventDefault(); setError('');
    if (!values.measured_at) { setError('Укажи дату замера'); return; }
    try { await onSubmit(values); }
    catch(err) { setError(err.message); }
  };

  return (
    <form onSubmit={handleSubmit}>
      <style>{CSS}</style>

      {/* Protocol banner */}
      <div style={{ display:'flex', gap:10, alignItems:'flex-start', background:'rgba(200,0,90,.08)', border:'1px solid rgba(200,0,90,.2)', borderRadius:12, padding:'10px 14px', marginBottom:16 }}>
        <span style={{ fontSize:'1.1rem', flexShrink:0 }}>📏</span>
        <p style={{ color:'rgba(242,238,249,.8)', fontSize:'.8rem', lineHeight:1.5, margin:0 }}>
          <strong style={{ color:'var(--accent,#C8005A)' }}>Протокол:</strong> утром, натощак, после туалета. Одна лента, одна одежда, одно время.
        </p>
      </div>

      {/* Цикл — только для женщин */}
      {gender === 'female' && (
        <details style={{ marginBottom:14, background:'rgba(155,111,212,.08)', border:'1px solid rgba(155,111,212,.2)', borderRadius:12, padding:'10px 14px' }}>
          <summary style={{ color:'#9B6FD4', fontSize:'.8rem', fontWeight:600, cursor:'pointer', listStyle:'none', display:'flex', alignItems:'center', gap:6 }}>
            🌙 Когда лучше делать замеры? (важно для девушек)
          </summary>
          <div style={{ marginTop:10, fontSize:'.78rem', lineHeight:1.7 }}>
            <p style={{ color:'rgba(200,185,220,.9)', margin:'0 0 8px' }}>
              Вес и объёмы меняются в течение месяца — это нормально, не паника.
            </p>
            <div style={{ display:'grid', gap:5 }}>
              {[
                ['✅ Дни 6-13', 'Лучшее время. Фолликулярная фаза — минимальный вес, самые точные замеры.', '#22C55E'],
                ['⚠️ Дни 1-5', 'Менструация. Вес может быть выше на 1-2 кг из-за воспаления.', '#F59E0B'],
                ['⚠️ Дни 15-28', 'Лютеиновая фаза. Задержка воды, вес выше на 1-3 кг — не пугайся.', '#F59E0B'],
              ].map(([phase, desc, color]) => (
                <div key={phase} style={{ display:'flex', gap:8, alignItems:'flex-start' }}>
                  <span style={{ color, fontSize:'.75rem', fontWeight:600, whiteSpace:'nowrap', minWidth:80 }}>{phase}</span>
                  <span style={{ color:'rgba(200,185,220,.7)', fontSize:'.75rem' }}>{desc}</span>
                </div>
              ))}
            </div>
            <p style={{ color:'rgba(200,185,220,.6)', fontSize:'.72rem', marginTop:8, marginBottom:0 }}>
              💡 Сравнивай замеры одной и той же фазы для объективной картины.
            </p>
          </div>
        </details>
      )}

      {error && (
        <div style={{ background:'rgba(239,68,68,.15)', border:'1px solid rgba(239,68,68,.3)', borderRadius:10, padding:'8px 12px', marginBottom:14, color:'#fca5a5', fontSize:'.85rem' }}>
          ⚠️ {error}
        </div>
      )}

      {GROUPS.map(group => (
        <div key={group.title} style={{ marginBottom:16 }}>
          <p style={{ color:'rgba(158,140,184,.6)', fontSize:'.65rem', textTransform:'uppercase', letterSpacing:'.08em', fontWeight:700, margin:'0 0 8px' }}>{group.title}</p>
          <div style={{ background:'rgba(26,21,37,.8)', border:'1px solid rgba(45,37,64,.8)', borderRadius:14, padding:'14px', display:'grid', gridTemplateColumns:'1fr 1fr', gap:12 }}>
            {group.fields.map(f => (
              <div key={f.key} style={f.type==='date' ? {gridColumn:'1/-1'} : {}}>
                <label style={{ display:'block', color:'rgba(158,140,184,.8)', fontSize:'.72rem', fontWeight:500, marginBottom:5 }}>
                  {f.label}{f.unit && <span style={{ color:'rgba(158,140,184,.5)', marginLeft:3 }}>({f.unit})</span>}
                </label>
                <input
                  className="mf-inp"
                  type={f.type||'number'} step="0.1" min="0"
                  placeholder={f.placeholder}
                  required={f.required}
                  value={values[f.key]??''}
                  onChange={e=>set(f.key, e.target.value)}
                />
                {/* Inline hint — всегда видна */}
                {f.hint && (
                  <p style={{ color:'rgba(158,140,184,.45)', fontSize:'.68rem', margin:'4px 0 0', lineHeight:1.4 }}>
                    {f.hint}
                  </p>
                )}
              </div>
            ))}
          </div>
        </div>
      ))}

      {/* Notes */}
      <div style={{ marginBottom:16 }}>
        <p style={{ color:'rgba(158,140,184,.6)', fontSize:'.65rem', textTransform:'uppercase', letterSpacing:'.08em', fontWeight:700, margin:'0 0 8px' }}>Заметки</p>
        <textarea
          className="mf-inp" rows={2} style={{ resize:'none' }}
          placeholder="Самочувствие, особенности..."
          value={values.notes??''} onChange={e=>set('notes',e.target.value)}
        />
      </div>

      <div style={{ display:'flex', gap:10, justifyContent:'flex-end' }}>
        {onCancel && (
          <button type="button" onClick={onCancel} style={{ padding:'.65rem 1.2rem', borderRadius:10, background:'rgba(255,255,255,.06)', border:'1px solid rgba(255,255,255,.1)', color:'rgba(158,140,184,.8)', cursor:'pointer', fontSize:'.85rem' }}>
            Отмена
          </button>
        )}
        <button type="submit" disabled={loading} style={{ padding:'.65rem 1.5rem', borderRadius:10, background:'var(--accent,#C8005A)', border:'none', color:'#fff', cursor:loading?'not-allowed':'pointer', fontSize:'.85rem', fontWeight:700, opacity:loading?.6:1, boxShadow:'0 4px 16px rgba(200,0,90,.35)', transition:'all .2s' }}>
          {loading ? 'Сохраняю...' : 'Сохранить замер'}
        </button>
      </div>
    </form>
  );
}
